import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react'
import cx from 'classnames'

interface Props
  extends DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children: React.ReactNode
  secondary?: boolean
  destructive?: boolean
  full?: boolean
  small?: boolean
  green?: boolean
}

export const Button = forwardRef<HTMLButtonElement, Props>(
  (
    { className = '', small, full, secondary, green, destructive, ...rest },
    ref,
  ) => {
    return (
      <button
        ref={ref}
        className={cx(
          'text-center whitespace-nowrap flex items-center font-medium leading-6 gotham rounded-md transition duration-150 ease-in-out sm:mt-0 sm:flex-shrink-0 sm:inline-flex sm:items-center sm:w-auto focus:outline-none focus:ring',
          {
            'bg-gray-200 hover:bg-gray-250 text-gray ring-gray':
              secondary && !green,
            'bg-blue text-white  hover:opacity-85':
              !green && !secondary && !destructive,
            'bg-red text-white  hover:opacity-85 ring-red': destructive,
            'bg-green-100  hover:opacity-85 ring-red text-green': green,
            'w-full flex items-center justify-center': full,
            'text-lg': !small,
            'px-2.5 py-1.5 text-base': small,
          },
          className,
        )}
        style={
          !small
            ? {
                padding: '14px 17px',
              }
            : {}
        }
        {...rest}
      />
    )
  },
)
